<template>
  <div>
    <h2><i>Linked In</i></h2>

    <section>
      <div class="row">
        <div class="col-1"><div class="img h1"></div></div>
        <div class="col-11">
          <div class="row">
            <div class="col-12"><i><b>User Name</b><br/> Designation</i><br/><br/></div>
            <div class="col-12">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Aenean euismod bibendum laoreet. <a>http://www.grc.org/programs.aspx?id=16786</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-1"><div class="img h1"></div></div>
        <div class="col-11">
          <div class="row">
            <div class="col-12"><i><b>User Name</b><br/> Designation</i><br/><br/></div>
            <div class="col-12">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,
              consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Aenean euismod bibendum laoreet.<br/><br/>
            </div>
            <div class="col-xs-12 col-md-6"><div class="img h2"></div></div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>


<script>
  export default {
    name: 'media',
    data () {
      return {
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-interact'}
      this.$parent.$parent.nextPage = false
      this.$parent.$parent.prevSlide = {name: 'article-media-youtube'}
      this.$parent.$parent.nextSlide = {name: 'article-media-google'}
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  section {
    margin: 20px auto;
    padding-bottom: 12px;
    &:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
    .img {
      border: 1px solid #cccccc;
      background-color: #eeeeee;
      width: 100%;
      &.h1 {
        height: 160px;
      }
      &.h2 {
        height: calc(320px + 0.5rem);
      }
      &.h3 {
        height: calc(480px + 1rem);
      }
    }
    .col-1 {
      flex:  0 0 190px;
      max-width: 190px;
    }
    .col-11 {
      flex: calc(100% - 190px);
      max-width: calc(100% - 190px);
    }
  }
</style>



// WEBPACK FOOTER //
// MediaLinkedInPage.vue?e50bc1fa